import ProjectsList from "@components/modules/projects/list";
import { NavigationProjects } from "@components/widgets/AppSubNav";
import { DemoModule, Modules } from "@components/widgets/DemoModule";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { ProjectListForClients } from "@src/components/modules/projects/list-for-client/ProjectListForClients";
import { useStore } from "@src/utils/hooks";
import { createFileRoute } from "@tanstack/react-router";
import { observer } from "mobx-react-lite";

const Page = observer(function Page() {
  const { authStore } = useStore();
  return (
    <MainLayout title={t`List of Projects`} navigation={<NavigationProjects />}>
      <DemoModule module={Modules.Projects}>
        {authStore.user?.type === "internal" ? (
          <ProjectsList />
        ) : (
          <ProjectListForClients />
        )}
      </DemoModule>
    </MainLayout>
  );
});

export const Route = createFileRoute("/projects/")({
  component: Page,
});
